import React, { useState, useEffect } from 'react';

function StudyNotes({ studyGuide, updateStudyGuide }) {
  const [notes, setNotes] = useState('');
  const [wordCount, setWordCount] = useState(0);
  const [autoSaveStatus, setAutoSaveStatus] = useState('');

  useEffect(() => {
    // Load existing notes from study guide
    const notesSection = studyGuide.sections.find(section => section.type === 'study-notes');
    if (notesSection) {
      setNotes(notesSection.content || '');
    }
  }, [studyGuide.sections]);

  useEffect(() => {
    // Update word count
    const words = notes.trim().split(/\s+/).filter(word => word.length > 0);
    setWordCount(words.length);
  }, [notes]);

  const handleNotesChange = (value) => {
    setNotes(value);

    // Auto-save to study guide
    const notesSection = studyGuide.sections.find(section => section.type === 'study-notes');
    if (notesSection) {
      updateStudyGuide({
        sections: studyGuide.sections.map(section =>
          section.id === notesSection.id
            ? { ...section, content: value }
            : section
        )
      });
    } else {
      // Create new study notes section
      const newSection = {
        id: Date.now(),
        type: 'study-notes',
        title: 'Study Session Notes',
        content: value
      };
      updateStudyGuide({
        sections: [...studyGuide.sections, newSection]
      });
    }

    // Show auto-save status
    setAutoSaveStatus('Saved');
    setTimeout(() => setAutoSaveStatus(''), 2000);
  };

  const insertTimestamp = () => {
    const now = new Date();
    const timestamp = `\n\n[${now.toLocaleString()}] `;
    handleNotesChange(notes + timestamp);
  };

  const clearNotes = () => {
    if (window.confirm('Are you sure you want to clear all notes?')) {
      handleNotesChange('');
    }
  };

  return (
    <div className="study-notes">
      <div className="notes-header">
        <h3>Study Session Notes</h3>
        <div className="notes-stats">
          <span className="word-count">{wordCount} words</span>
          {autoSaveStatus && <span className="auto-save-status">{autoSaveStatus}</span>}
        </div>
      </div>

      <div className="notes-toolbar">
        <button className="btn btn-secondary btn-small" onClick={insertTimestamp}>
          <span className="btn-icon">📅</span>
          Timestamp
        </button>
        <button className="btn btn-secondary btn-small" onClick={clearNotes}>
          <span className="btn-icon">🗑️</span>
          Clear
        </button>
      </div>

      <div className="notes-editor">
        <textarea
          value={notes}
          onChange={(e) => handleNotesChange(e.target.value)}
          placeholder="Write your study session notes here... Record insights, questions, prayer requests, applications, etc."
          rows={15}
        />
      </div>

      <div className="notes-footer">
        <div className="notes-tips">
          <h4>Tips for Study Notes:</h4>
          <ul>
            <li>Record key insights and observations</li>
            <li>Note questions that arise during study</li>
            <li>Write down personal applications</li>
            <li>Include prayer requests and praises</li>
            <li>Track progress and goals</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default StudyNotes;